import React from "react";

const InputField = props => (<div>
    <label htmlFor={props.inputId} style={props.contactFormLabel}>{props.label}*</label>
    <br />
    {props.textarea ?
        <textarea type={props.inputType} name={props.inputId} id={props.inputId} value={props.value} onChange={props.saveNewValue} rows={props.rows} cols={props.cols} style={props.contactFormField} /> : <input type={props.inputType} name={props.inputId} id={props.inputId} value={props.value} onChange={props.saveNewValue} style={props.contactFormField} />}
</div>);


export default InputField;


// WEBPACK FOOTER //
// ./src/Components/inputField.jsx